import { React, PropTypes, get, Card, FelaComponent, MenuContainer as Menu, noop } from '../dependencies';

import { restaurantShape } from './propTypes';
import { RestaurantLink, StartTrain, Favourite } from './RestaurantActions';

const rule = ({ theme }) => ({
    margin: '5px 10px',
    padding: '8px 0',

    '& .ant-card-head-title': {
        fontFamily: theme.fonts.heading,
        fontSize: '30px',
        textAlign: 'center',
    },
});

const Restaurant = ({ id, url, name, menu, isFavourite, toggleRestaurantFavourite }) => (
    <FelaComponent
        rule={rule}
        render={({ className }) => (
            <Card
                className={className}
                title={name}
                actions={[
                    <RestaurantLink url={url} />,
                    <StartTrain />,
                    <Favourite favourite={isFavourite} onToggle={() => toggleRestaurantFavourite(id)} />,
                ]}
            >
                <Menu restaurantId={id} menu={get(menu, 'data')} isPristine={menu.isPristine} />
            </Card>
        )}
    />
);

Restaurant.propTypes = {
    ...restaurantShape,
    toggleRestaurantFavourite: PropTypes.func,
};

Restaurant.defaultProps = {
    menu: null,
    toggleRestaurantFavourite: noop,
};

export default Restaurant;
